export { COMPONENTS_MODULE_NAME } from './supplier.components.module'